import React, { useEffect, useRef } from 'react';

function FilterPopup({ filters, onFilterChange, onReset, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const filterGroups = [
    {
      id: 'status',
      title: 'Status',
      options: [
        { id: 'Active', label: 'Active' },
        { id: 'Inactive', label: 'Inactive' },
      ],
    },
    {
      id: 'conflict',
      title: 'Conflict',
      options: [
        { id: 'Yes', label: 'Yes' },
        { id: 'No', label: 'No' },
      ],
    },
    {
      id: 'ownership',
      title: 'Ownership',
      options: [
        { id: 'High', label: 'High (>= 50%)' },
        { id: 'Low', label: 'Low (< 50%)' },
      ],
    },
    {
      id: 'version',
      title: 'Version Type',
      options: [
        { id: 'Original', label: 'Original' },
        { id: 'Version', label: 'Version' },
      ],
    },
  ];

  return (
    <div className="popup-dropdown filter-dropdown" ref={containerRef}>
      <div className="popup-dropdown-header">
        <span className="popup-title">Filters</span>
        <button className="reset-all-btn" onClick={onReset}>
          Reset All
        </button>
      </div>

      <div className="filter-groups-list">
        {filterGroups.map((group) => (
          <div key={group.id} className="filter-popup-group">
            <div className="filter-group-title">{group.title}</div>
            <div className="filter-group-options">
              {group.options.map((opt) => {
                const isSelected = filters[group.id] === opt.id;
                return (
                  <button
                    key={opt.id}
                    className={`filter-badge-btn ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      // Toggle: if clicked and active, revert to null (all)
                      if (isSelected) {
                        onFilterChange(group.id, null);
                      } else {
                        onFilterChange(group.id, opt.id);
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FilterPopup;
